import { render, staticRenderFns } from "./CustomDatePicker.vue?vue&type=template&id=1af0a822&"
import script from "./CustomDatePicker.vue?vue&type=script&lang=js&"
export * from "./CustomDatePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports